import filterIcon from '../../_metronic/images/filter.svg'
import filterBlueIcon from '../../_metronic/images/filterBlueIcon.svg'
import filterFillIcon from '../../_metronic/images/filter-fill.svg'

import { filterConfig, filterOptions, filterType, option } from '../../utils/Global.types'
import { useState } from 'react'
import { GLOBAL_CONSTANTS } from '../../utils/GlobalConstants'
type filterProps = {
  colors?: string
  filterOptions: filterOptions
  initialFilter: filterOptions
  setFilterOptions: React.Dispatch<React.SetStateAction<filterOptions>>
  filterConfig: filterConfig[]
}
type FilterValue = string | number | boolean | null | undefined;

const handleSelectValue = (value: FilterValue) => {
  if (typeof value === 'boolean') {
    return value
      ? GLOBAL_CONSTANTS.filterBooleanValue.true
      : GLOBAL_CONSTANTS.filterBooleanValue.false
  } else if (value === null || !Boolean(value)) {
    return ''
  } else {
    return value
  }
}
const Filter = ({
  colors,
  initialFilter,
  filterOptions,
  setFilterOptions,
  filterConfig,
}: filterProps) => {
  const [localFilterOptions, setLocalFilterOptions] = useState(filterOptions)
  const onChangeHandler = (value: string, key: keyof filterOptions, type: filterType) => {
    if (type === 'BOOLEAN') {
      setLocalFilterOptions((prev: filterOptions) => ({
        ...prev,
        [key]: value === GLOBAL_CONSTANTS.filterBooleanValue.true ? true : false,
      }))
    } else {
      setLocalFilterOptions((prev: filterOptions) => ({ ...prev, [key]: value }))
    }
  }
  return (
    <div className='d-flex gap-5'>
      <div className='m-0 '>
        <button
          className='btn btn-light-primary btn-active-light-primary fw-bold fs-base ms-5'
          data-kt-menu-trigger='click'
          data-kt-menu-placement='bottom-end'
        >
          <span className='svg-icon svg-icon-6 svg-icon-muted me-1'>
            {colors === 'white' ? (
              <img
                src={
                  JSON.stringify(initialFilter) === JSON.stringify(filterOptions)
                    ? filterBlueIcon
                    : filterFillIcon
                }
                alt=''
                className='svg-icon svg-icon-1 text-gray-600'
              />
            ) : (
              <img
                src={
                  JSON.stringify(initialFilter) === JSON.stringify(filterOptions)
                    ? filterIcon
                    : filterFillIcon
                }
                alt=''
                className='svg-icon svg-icon-1 text-gray-600'
              />
            )}
          </span>
          Filter
        </button>

        <div
          className='menu menu-sub menu-sub-dropdown w-350px w-md-550px'
          data-kt-menu='true'
          id='kt_menu_63b3cb4f9c10f'
        >
          <div className='px-7 py-5'>
            <div className='fs-4 fw-bold text-gray-900'>Filter Options</div>
          </div>
          <div className='separator border-gray-200' />
          <div className='px-7 py-5'>
            <div className='row row-cols-1 row-cols-lg-2'>
              {filterConfig.map(({ label, key, options, type }: filterConfig) => (
                <div className='col mb-3'>
                  <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                    <span>{label}</span>
                  </label>
                  <select
                    className='form-select form-select-solid'
                    value={handleSelectValue(localFilterOptions[key as keyof filterOptions])}
                    aria-label='Select example'
                    onChange={(e) =>
                      onChangeHandler(e.target.value, key as keyof filterOptions, type)
                    }
                  >
                    <option value={''}>Select an option</option>
                    {options.map(({ value, name }: option) => (
                      <option value={value}>{name}</option>
                    ))}
                  </select>
                </div>
              ))}
            </div>
            <div className='d-flex flex-row justify-content-end mt-4'>
              <button
                type='button'
                className='btn btn-light me-3 fs-7 fw-semibold text-gray-600'
                onClick={() => {
                  setLocalFilterOptions(initialFilter)
                  setFilterOptions(initialFilter)
                }}
              >
                Reset
              </button>
              <button
                type='button'
                data-kt-menu-dismiss='true'
                onClick={() => {
                  setFilterOptions({
                    ...localFilterOptions,
                    perPage: filterOptions.perPage,
                    searchText: filterOptions.searchText,
                    page: 1,
                  })
                }}
                className='btn btn-primary fs-7 fw-semibold text-gray-100'
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Filter
